import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'

export class ReservationPromotionRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async assignToReservation(reservationWid, value) {
		const { data } = await apiRequest({
			url: apiUrl('/world/api/reservation-promotions/assign-to-reservation'),
			method: 'POST',
			body: {
				wid: reservationWid,
				value: value
			},
			expect: 'json',
			throwOnNonOk: true
		})

		return data
	}

	async deleteReservationPromotion(reservationPromotionId) {
		const { data } = await apiRequest({
			url: apiUrl('/world/api/reservation-promotions/delete'),
			method: 'POST',
			body: {
				promotionId: reservationPromotionId
			},
			expect: 'json',
			throwOnNonOk: true
		})

		return data
	}
}

export const reservationPromotionRepository = new ReservationPromotionRepository()
